import {
  useFollowCommunity,
  useIsFollowingCommunity,
  useUnfollowCommunity,
} from '@queries/follows';
import { Button, useAuthStore } from '@sunrise-ui/primitives';
import React from 'react';

type Props = {
  communityId?: string;
  disabled?: boolean;
};

export default function CommunityFollowButton({
  communityId,
  disabled = false,
}: Props) {
  const { isAuthenticated } = useAuthStore();
  const { mutate: followCommunity, isPending: isPendingFollow } =
    useFollowCommunity();
  const { mutate: unfollowCommunity, isPending: isPendingUnfollow } =
    useUnfollowCommunity();
  const { isFollowing, isLoading: isLoadingFollowing } =
    useIsFollowingCommunity(communityId);

  const isLoading =
    isLoadingFollowing || isPendingFollow || isPendingUnfollow || !communityId;

  const handlePress = () => {
    if (!communityId) return;

    if (isFollowing) {
      unfollowCommunity(communityId);
    } else {
      followCommunity(communityId);
    }
  };

  if (!communityId) {
    return null;
  }

  const buttonText = !isAuthenticated
    ? 'Follow'
    : isFollowing
      ? 'Unfollow'
      : 'Follow';

  return (
    <Button
      size="small"
      onPress={handlePress}
      disabled={isLoading || disabled}
      loading={isLoading}
    >
      {buttonText}
    </Button>
  );
}
